module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#business",
      toString: function () {
        return this.url;
      }
    }